import React, { useEffect, useState } from "react";
import { Box, Button, IconButton, useTheme } from "@mui/material";
import Header from "components/Header";
import { useDispatch, useSelector } from "react-redux";
import { AddCircleOutline, RemoveCircleOutline } from "@mui/icons-material";
import MUIDataTable from "mui-datatables";
import moment from "moment";
import "moment/locale/id";
import FloatingAlert from "components/FloatingAlert";
import { setMessage, setStatus } from "state";
import KonfirmasiModal from "components/Modals/KonfirmasiModal";
import {
  fetchChangeStatusSetoran,
  fetchDeleteSetoran,
  fetchEditCatatanSetoran,
  fetchListSetoran,
} from "state/setoranAction";
import formatRupiah from "utils/formatRupiah";
import EditCatatanModal from "components/Modals/EditCatatanModal";
import { fetchListKaryawanWithTabungan } from "state/karyawanActions";
import { useNavigate } from "react-router-dom";
import SortableHeader from "components/SortableHeader";
moment.locale("id");

const Tabungan = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openKonfirmasi, setOpenKonfirmasi] = useState(false);
  const [openEditCatatan, setOpenEditCatatan] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [isDelete, setIsDelete] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(30);

  const { status, message } = useSelector((state) => state.global);
  const { list_setoran } = useSelector((state) => state.setoran);

  const { list_tabungan_karyawan } = useSelector((state) => state.karyawan);

  useEffect(() => {
    dispatch(fetchListKaryawanWithTabungan());
  }, []);

  const handleCloseSnackbar = () => {
    dispatch(setStatus("default"));
    dispatch(setMessage(""));
    dispatch(fetchListSetoran());
    setIsDelete(false);
  };

  const handleSetujui = () => {
    dispatch(fetchChangeStatusSetoran(selectedData.id));
    setOpenKonfirmasi(false);
    setSelectedData(null);
  };
  const handleDelete = () => {
    dispatch(fetchDeleteSetoran(selectedData.id));
    setOpenKonfirmasi(false);
    setSelectedData(null);
  };
  const handleSubmitEditKaryawan = (value) => {
    dispatch(fetchEditCatatanSetoran(selectedData.id, value));
    setOpenEditCatatan(false);
    setSelectedData(null);
  };

  const columnsTabungan = [
    {
      name: "id_karyawan",
      label: "ID Karyawan",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
      },
    },
    {
      name: "nama_karyawan",
      label: "Nama Karyawan",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
      },
    },
    {
      name: "saldo_saat_ini",
      label: "Total Tabungan",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),

        customBodyRender: (value) => formatRupiah(value),
      },
    },
    {
      name: "aksi",
      label: "Aksi",
      options: {
        filter: false,
        sort: false,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
          />
        ),
        customBodyRender: (value, tableMeta) => {
          const id = tableMeta.rowData[0]; // Ambil ID dari kolom pertama
          return (
            <>
              <Button
                variant="outlined"
                color="info"
                startIcon={<AddCircleOutline />}
                onClick={() => {
                  const datatabungan = list_tabungan_karyawan.find(
                    (item) => item.id_karyawan === id,
                  );
                  navigate("/setortabungan", { state: { datatabungan } });
                }}
                style={{ marginRight: 8 }}
              >
                Setor
              </Button>

              <Button
                variant="outlined"
                color="warning"
                startIcon={<RemoveCircleOutline />}
                onClick={() => {
                  const datatabungan = list_tabungan_karyawan.find(
                    (item) => item.id_karyawan === id,
                  );
                  navigate("/tariktabungan", { state: { datatabungan } });
                }}
              >
                Tarik
              </Button>
            </>
          );
        },
      },
    },
  ];

  const options = {
    selectableRows: "none",
    filterType: "dropdown",
    fixedHeader: false,
    fixedSelectColumn: false,
    responsive: "standard",
    rowsPerPageOptions: [30, 60, list_tabungan_karyawan.length],
    rowsPerPage: rowsPerPage,
    onChangeRowsPerPage: (numberOfRows) => setRowsPerPage(numberOfRows),
  };

  return (
    <Box m="1.5rem 2.5rem">
      <Header
        title="Tabungan"
        subtitle="Daftar Tabungan dari setiap karyawan."
      />

      <Box
        mt="40px"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: theme.palette.primary.light,
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderTop: "none",
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${theme.palette.secondary[200]} !important`,
          },
        }}
      >
        <MUIDataTable
          title={""}
          data={list_tabungan_karyawan}
          columns={columnsTabungan}
          options={options}
        />
        <FloatingAlert
          open={message.length > 0}
          onClose={handleCloseSnackbar}
          message={message}
          severity={status === "failed" ? "error" : status}
        />
        <KonfirmasiModal
          titleType={isDelete ? "Hapus" : "Setujui"}
          subtitleType={isDelete ? "Menghapus" : "Menyetujui"}
          dataWillProses={"Setoran Ini"}
          open={openKonfirmasi}
          onClose={() => setOpenKonfirmasi(false)}
          onSubmit={() => (isDelete ? handleDelete() : handleSetujui())}
          textButtonPositif={isDelete ? "Hapus" : "Setujui"}
        />
        <EditCatatanModal
          open={openEditCatatan}
          dataEdit={selectedData}
          onClose={() => setOpenEditCatatan(false)}
          onSubmit={(value) => handleSubmitEditKaryawan(value)}
        />
      </Box>
    </Box>
  );
};

export default Tabungan;
